import {
  Dropdown,
  DropdownContent,
  DropdownTrigger,
} from "@/components/ui/dropdown";
import {useData} from "@/stores/data";
import {Link, useLocation} from "react-router-dom";
import {ChevronUp} from "lucide-react";
import {cx} from "class-variance-authority";

export default function SidebarMobileItem({icon, title, link, links, dropUp}) {
  const {setSidebarState} = useData();
  const location = useLocation();
  const isActive = location.pathname === link;

  return dropUp ? (
    <Dropdown>
      <DropdownTrigger asChild>
        <button
          className={cx(
            "relative flex flex-col gap-1 items-center justify-center p-2 rounded-xl transition-all duration-200",
            "hover:bg-gray-100 active:scale-95",
            "min-w-[60px] min-h-[60px]"
          )}
        >
          <div className="text-gray-600">{icon}</div>
          <span className="text-[10px] text-gray-500 font-medium text-center leading-tight whitespace-nowrap">
            {title}
          </span>
          <ChevronUp className="absolute -top-1 -right-1 w-3 h-3 text-gray-400 bg-white rounded-full p-0.5 shadow-sm" />
        </button>
      </DropdownTrigger>
      <DropdownContent side="top" align="center" className="mb-2 min-w-[120px]">
        <div className="flex flex-col bg-white rounded-lg shadow-lg border border-gray-100 p-2">
          {links.map((item, index) => {
            const isLinkActive = location.pathname === item.link;
            return (
              <Link
                className={cx(
                  "px-3 py-2 text-sm rounded-md transition-all duration-200",
                  "hover:bg-gray-50 active:scale-95",
                  isLinkActive
                    ? "bg-blue-50 text-blue-600 font-medium"
                    : "text-gray-700"
                )}
                key={index}
                to={item.link}
                onClick={() => setSidebarState(false)}
              >
                {item.title}
              </Link>
            );
          })}
        </div>
      </DropdownContent>
    </Dropdown>
  ) : (
    <Link
      to={link}
      className={cx(
        "flex flex-col gap-1 items-center justify-center p-2 rounded-xl transition-all duration-200",
        "hover:bg-gray-100 active:scale-95",
        "min-w-[60px] min-h-[60px]",
        isActive && "bg-blue-50"
      )}
      onClick={() => setSidebarState(false)}
    >
      <div
        className={cx(
          "transition-colors duration-200",
          isActive ? "text-blue-600" : "text-gray-600"
        )}
      >
        {icon}
      </div>
      <span
        className={cx(
          "text-[10px] font-medium text-center leading-tight transition-colors duration-200 whitespace-nowrap",
          isActive ? "text-blue-600" : "text-gray-500"
        )}
      >
        {title}
      </span>
    </Link>
  );
}
